import { render, staticRenderFns } from "./KlfsHeader.vue?vue&type=template&id=744281ed&scoped=true"
import script from "./KlfsHeader.vue?vue&type=script&lang=js"
export * from "./KlfsHeader.vue?vue&type=script&lang=js"
import style0 from "./KlfsHeader.vue?vue&type=style&index=0&id=744281ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744281ed",
  null
  
)

export default component.exports